import { Pipe, PipeTransform } from '@angular/core';
/*
 * Receives birthDay, birthMonth, birthYear as three separate parameters
 * and returns the string birthDay/birthMonth/birthYear
*/
@Pipe({name: 'dateOfBirth'})
export class DateOfBirthPipe implements PipeTransform {
    transform(args: string[]): any {
        return args[0] + '/' + args[1] + '/' + args[2];
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/date-of-birth.pipe.ts